import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../Css/Values.css';

const EducationTraining = () => {
  const rowsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target); // Observe only once
          }
        });
      },
      { threshold: 0.3 } // Trigger when 30% of the element is visible
    );

    rowsRef.current.forEach((valuesrow) => {
      if (valuesrow) {
        observer.observe(valuesrow);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="container education-training-container">
      <div className="edu-traning-contender">
        <div className="edu-heading">
          <h3>EDUCATION & <span> TRAINING</span></h3>
        </div>
        <h2 className="phase-2">
          <i className="fa fa-check-square-o" aria-hidden="true">Phase-1</i>
        </h2>
        <div className="valuesrow" ref={(el) => (rowsRef.current[0] = el)}>
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 image-column">
            <div className="image-wrapper">
              <img
                className="phase-image left"
                src='/assets/edu-training/value-aweour.png'
                alt="Values Awareness"
              />
            </div>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 content-column">
            <div className="edu-containt">
              <div className="edu-h4">
                <h4>Values Awareness</h4>
              </div>
              <div className="edu-p">
                <p>
                  Putting the seed of values in the life of the students by kindling
                  interest in the values through life changing and basic value based
                  seminars.
                </p>
              </div>
              <div className="edu-btn">
                <Link to="/values/valuesawareness" className="btn btn-success">
                  Read More
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* phase-1 End */}
        <h2 className="phase-2">
          <i className="fa fa-graduation-cap" aria-hidden="true">Phase-2</i>
        </h2>
        <div className="valuesrow" ref={(el) => (rowsRef.current[1] = el)}>
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 content-column">
            <div className="edu-containt right-content">
              <div className="edu-h4-even">
                <h4>Values Education</h4>
              </div>
              <div className="p-even">
                <p>
                  Once the interest is awakened, initialization of values in the
                  life of the individual become the utmost need
                </p>
              </div>
              <div className="edu-btn-even">
                <Link to="/values/valueseducation" className="btn btn-success">
                  Read More
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 image-column">
            <div className="image-wrapper">
              <img
                className="phase-image right"
                src='/assets/edu-training/value-education.jpeg'
                alt="Values Education"
              />
            </div>
          </div>
        </div>
        {/* phase-2 end  */}
        <h2 className="phase-2">
          <i className="fa fa-heartbeat" aria-hidden="true">Phase-3</i>
        </h2>
        <div className="valuesrow" ref={(el) => (rowsRef.current[2] = el)}>
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 image-column">
            <div className="image-wrapper">
              <img
                className="phase-image left"
                src='/assets/edu-training/value-cultivation.jpg'
                alt="Values Cultivation"
              />
            </div>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 content-column">
            <div className="edu-containt">
              <div className="edu-h4">
                <h4>Values Cultivation</h4>
              </div>
              <div className="edu-p">
                <p>
                  After the seed of values is sown and heart becomes fertile through
                  knowledge transmission, the background is set for
                </p>
              </div>
              <div className="edu-btn">
                <Link to="/values/valuescultivation" className="btn btn-success">
                  Read More
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* phase-3 End */}
        <h2 className="phase-2">
          <i className="fa fa-handshake-o" aria-hidden="true">Phase-4</i>
        </h2>
        <div className="valuesrow" ref={(el) => (rowsRef.current[3] = el)}>
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 content-column">
            <div className="edu-containt right-content">
              <div className="edu-h4-even">
                <h4>Values in Action</h4>
              </div>
              <div className="p-even">
                <p>
                  While being empowered by necessary values in one’s life, youth
                  becomes inspired to distribute the values for the benefit of
                  others.
                </p>
              </div>
              <div className="edu-btn-even">
                <Link to="/education & training/phase4" className="btn btn-success">
                  Read More
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 image-column">
            <div className="image-wrapper">
              <img
                className="phase-image right"
                src='/assets/edu-training/value-action.jpg'
                alt="Values in Action"
              />
            </div>
          </div>
        </div>
        {/* phase-4 end  */}
      </div>
    </div>
  );
};

export default EducationTraining;